export default {
  loading: 'Preise werden geladen…',
  default_modal: {
    title: 'Standard-Preisliste',
    description:
      'Die Basispreise, die jeder Partner ohne eigene Preise erbt. Änderungen betreffen laufende Lizenzen nie.',
    saved: 'Standard-Preisliste gespeichert.',
  },
  buttons: {
    edit: 'Bearbeiten',
    cancel: 'Abbrechen',
    save: 'Speichern',
  },
  toasts: {
    load_error: 'Die Preisdaten konnten nicht geladen werden.',
    save_error: 'Speichern fehlgeschlagen — bitte erneut versuchen.',
    prices_saved: 'Preisliste gespeichert.',
    license_created: 'Lizenz erstellt.',
    lifecycle: {
      pause: 'Lizenz pausiert.',
      resume: 'Lizenz fortgesetzt.',
      cancel: 'Lizenz gekündigt.',
    },
  },
  price_book: {
    title: 'Preisliste',
    read_only_notice:
      'Partnerpreise überschreiben die Standard-Preisliste. Laufende Lizenzen behalten ihre fixierten Preise.',
    editing_notice: 'Bearbeitung — neue Preise gelten nur für ab jetzt erstellte Lizenzen.',
    columns: {
      service: 'Dienst',
      cost_price: 'Bruttopreis ({{currency}}/Monat, inkl. MwSt.)',
    },
    add_ons: 'Zusatzmodule',
    missing_price:
      '{{name}} ist aktiviert, hat aber keinen Preis — legen Sie einen fest oder deaktivieren Sie den Dienst.',
    incomplete_tier:
      '{{name}} braucht sowohl einen Mengenpreis als auch die Anzahl an Live-Standorten, ab der er gilt — oder keines von beiden.',
    invalid_tier:
      'Der Mengenpreis von {{name}} muss unter dem Standardpreis liegen und ab mindestens 2 Live-Standorten gelten.',
    tier: {
      from: 'Mengenpreis ab',
      live_locations: 'Live-Standorten',
      counted_one: 'Dieser Partner zählt {{count}} lizenzierten Live-Standort für den Mengenpreis.',
      counted_other: 'Dieser Partner zählt {{count}} lizenzierte Live-Standorte für den Mengenpreis.',
    },
    snapshot_note:
      'Preise werden bei der Lizenzerstellung fixiert — Änderungen an der Liste betreffen laufende Lizenzen nie.',
    types: {
      base: 'Basis',
      add_on: 'Zusatzmodul',
    },
  },
  volume_discount: {
    title: 'Mengenrabatt',
    read_only_notice:
      'Sobald eine Monatsrechnung die Schwellenanzahl an Lizenzen abrechnet, wird der Rabatt auf alle Lizenzgebühren dieses Zyklus gewährt.',
    editing_notice: 'Bearbeitung — die neuen Werte gelten ab dem nächsten Abrechnungszyklus.',
    threshold_label: 'Lizenz-Schwelle',
    percent_label: 'Rabatt',
    invalid: 'Geben Sie eine Schwelle von mindestens 1 und einen Rabatt zwischen 0 und 100 % ein.',
    saved: 'Mengenrabatt gespeichert.',
    note: 'Zählt die im Zyklus selbst abgerechneten Lizenzen; übertragene Monate sind ausgenommen. 0 % (Standard) deaktiviert den Rabatt — sonst käme er zum Mengenpreis der Preisliste hinzu.',
  },
  licenses: {
    test_restaurant_unlicensable: 'Ein Testrestaurant wird nie abgerechnet und kann daher keine Lizenz haben.',
    title: 'Restaurant-Lizenzen',
    select_company: 'Restaurant auswählen',
    add_license: 'Lizenz hinzufügen',
    no_companies: 'Dieser Partner hat noch keine Restaurants.',
    no_licenses: 'Für dieses Restaurant gibt es noch keine Lizenzen.',
    activated_at: 'Aktiv seit',
    next_period_preview: 'Nächster Monat (anteilig, vor Mengenrabatt)',
    statuses: {
      active: 'Aktiv',
      paused: 'Pausiert',
      canceled: 'Gekündigt',
    },
    columns: {
      product: 'Dienst',
      locked_price: 'Fixierter Preis / Monat',
      quantity: 'Anzahl',
      trial_ends: 'Kostenlos bis',
    },
    price_tiers: {
      volume: 'Mengenpreis',
      locked: 'Bestandspreis',
    },
  },
  lifecycle: {
    pause: {
      action: 'Pausieren',
      title: 'Diese Lizenz pausieren?',
      description:
        'Pausierte Tage werden nicht berechnet. Die Lizenz behält ihre fixierten Preise und kann jederzeit fortgesetzt werden.',
      confirm: 'Pausieren',
    },
    resume: {
      action: 'Fortsetzen',
      title: 'Diese Lizenz fortsetzen?',
      description: 'Die Abrechnung läuft ab heute zu den fixierten Preisen weiter.',
      confirm: 'Fortsetzen',
    },
    cancel: {
      action: 'Lizenz kündigen',
      title: 'Diese Lizenz kündigen?',
      description:
        'Der laufende Monat wird anteilig bis heute berechnet. Dies kann nicht rückgängig gemacht werden — eine neue Lizenz würde zu aktuellen Listenpreisen erstellt.',
      confirm: 'Lizenz kündigen',
    },
  },
  add_license: {
    title: 'Lizenz hinzufügen',
    description: 'Wählen Sie die Dienste für dieses Restaurant. Die Preise werden bei der Erstellung fixiert.',
    per_month: ' / Monat',
    create: 'Lizenz erstellen',
    no_priced_products:
      'Für diesen Partner hat noch kein Produkt einen gültigen Preis — legen Sie zuerst die Preisliste fest.',
  },
};
